/*
 * @Description: 说明 需要设置的头部title
 * @version: 版本 3.4
 * @Author: 作者 褚章一
 * @Date: 2020-07-31 16:51:25
 * @LastEditTime: 2024-11-05 10:22:18
 */
export default {
  // 路由：title名
  '404': '404',
  'contract': '合同',
  'orders': '提货',
  'contract-baseDetail': '合同详情',
  'contract-basisDetail': '合同详情',
  'contract-cornDetail': '合同详情',
  'contract-detail': '合同详情',
  'contract-eContract': '电子合同',
  'orders-cornDetail': '提货详情',
  'orders-detail': '提货详情',
  'workOrder': '工单列表',
  'workOrder-groupIndex': '工单列表',
  'workOrder-edit': '创建工单',
  'offers': '报价',
  'offers-selectUser': '选择客户',
  'offers-selectOil': '选择油厂',
  'offers-share': '报价分享',
  'contract-push': '合同推送',
  'contract-approvalDetail': '变更合同审批详情',
  'workOrder-splitContract': '合同变更',
  'portrait': '画像',
  'portrait-addRelatedParties': '新增关联主体',
  'portrait-coupons': '优惠券列表',
  'portrait-invoiceCenter': '发票中心',
  'portrait-message': '通知',
  'portrait-payAmount': '待转账金额',
  'portrait-payList': '账单',
  'portrait-billExportRecords': '导出记录',
  'portrait-personalInformation': '个人信息',
  'portrait-editPersonalInfo': '客户信息',
  'portrait-selectSalesman': '选择业务员',
  'portrait-addressLog': '定位历史记录',
  'performance': '绩效',
  'offers-list': '报价',
  'contract-cancelContract': '取消合同',
  'transactionConfig-portOrSite': '选择港口',
  'transactionConfig-approvalSubmission': '审批提交',
  'supplierManage': "供应商信息",
  'supplierManage-addSupplier': "供应商添加",
  'supplierManage-chooseSupplier': "供应商切换",
  'receiveInfo-address': '收货地址',
  'receiveInfo-addAddress': '添加收货地址',
  'receiveInfo-receiver': '接货人',
  'offers-basis': '基差管理',
  'offers-basisAdd': '新增报价',
  'offers-basisEdit': '编辑报价',
  'managedFutures': '期货管理',
  'performance-detail': '绩效详情',
  'managedFutures-pointPrice': '东耀点价',
  'portrait-customerProfile': '客户档案',
  'portrait-sendAuthentication': '发送认证',
  'offers-cronPlaceOrderShare': '站台玉米报价分享下单',
  'offers-beanPlaceOrderShare': '站台豆粕报价分享下单',
  'offers-beanAssistOrderResult': '辅助下单成功',
  'deliveryManagement': '发货管理',
  'deliveryManagement-matchProcure': '发货管理',
  'deliveryManagement-matchProcureConfim': '发货管理',
  'deliveryManagement-confirmReceipt': '确认收货',
  'merchantQuotation-cornIndex': '玉米报价管理',
  'merchantQuotation-cronEdit': '新增玉米报价',
  'supplierManage-sendOutGoods': '发货磅单',
  'supplierManage-advanceCharge': '预付款',
  'supplierManage-merchantShipment': '商家发货',
  'limitManagement': '豆粕限量提货管理',
  'offers-speedUpOrder': '极速达下单',
  'offers-billingScreenshot': '开单截图',
  'contract-valenceOfVertex': '点价申请',
  'contract-washBasisApply': '洗基差申请',
  'contract-washBasisRecord': '洗基差记录',
  'contract-coutingOrMonthRecord': '转月记录',
  'contract-pointResult': '点价结果',
  'portrait-cardList': '我的银行卡',
  'visit-list': '拜访记录查询',
  'visit-inspectionList': '养殖服务报告',
  'visit-inspectionEdit': '养殖服务报告',
  'visit-inspectionDetail': '巡场报告详情',
  'visit-inspectionCustomer': '客户查看报告',
  'diagnosis-create': '创建养殖诊断工单',
  'diagnosis-list': '诊断工单',
  'diagnosis-detail': '工单详情',
  'crm': 'CRM首页',
  'crm-beanDeliveryPlan': '提货计划周客户分配',
  'oilExpenseReimbursement': '油费报销',
  'oilExpenseReimbursement-apply': '申请油费报销',
  'crm-map': '拜访地图',
  'crm-search': '客户',
  'crm-clockin': '打卡',
  'clockIn-log': '打卡记录',
  'clockIn-travelAbnormalRemind': '差旅异常提醒',
  'clockIn-travelAbnormalAppeal': '差旅异常申诉',
  'crm-stayapply': '住宿申请',
  'portrait-addClue': '新增未注册',
  'performance-commission-detail': '提成及奖惩明细',
  'eggInvoice-detail': '发票详情',
  'orders-yuhunliaoAfterSale': '退货申请',

  'crm-attendanceDetail': '考勤明细',
  'crm-customerNewDetail': '客户明细',
  'task-weeklyVisitEdit': '创建任务',
  'task-edit': '创建任务',
  'task-weeklyTravelDetail': '任务详情',
  'task-weeklyVisitRouteMap': '推荐拜访路线',
  'task-hotelApply': '酒店差旅申请单',
  'task-hotelApplyRecords': '酒店申请记录',
  'task-travelAppealList': '申诉明细',
  'task-list': '任务',
  'location-help': '定位权限设置帮助',
  'partner': '粮巴巴合作方管理助手',
  'partner-register': '补充员工信息',
  'partner-customerList': '我的客户',
  'partner-customerEdit': '添加客户',
  'partner-check': '客户查重',
  'partner-logList': '操作记录',
  'partner-logDetail': '操作详情',
  'premixPurchasePlan': '预混料报采计划',
  'premixPurchasePlan-edit': '新增报采计划',
  'premixPurchasePlan-dispatchRecords': '发货记录',

  'message': '消息',
  'crm-customerList': '客户',
  'crm-thecharts': '排行榜'
}
